<template>
  <w-dialog :show-close="false" :show="show" class="confirm-wall">
    <div class="confirm-content">
      <i :class="['w-icon-qiangtixing position-center', type]"></i>
      <p class="content-txt">
        {{contentTxt}}
        <br />
        <span class="content-small-txt">
          {{contentSmallTxt}}
        </span>
        <span class="content-small-txt warning">
          {{contentSmallredTxt}}
        </span>
      </p>
    </div>
    <div slot="footer">
      <span :class="['btn', type]" @click="success">{{successTxt}}</span>
      <span v-if="isCancelBtn" class="btn cancel" @click="cancel">{{cancelTxt}}</span>
    </div>
  </w-dialog>
</template>
<script>
export default {
  name: 'ConfirmDialog',
  props: {
    deleteData: {},
    type: {
      type: String,
      default: 'primary'
    },
    show: {
      type: Boolean,
      default: false
    },
    contentTxt: {
      type: String,
      default: '确定要这么做吗'
    },
    contentSmallTxt: {
      type: String,
      default: ''
    },
    contentSmallredTxt: {
      type: String,
      default: ''
    },
    successTxt: {
      type: String,
      default: '确定'
    },
    isCancelBtn: {
      type: Boolean,
      default: true
    },
    cancelTxt: {
      type: String,
      default: '取消'
    }
  },
  created () {

  },
  methods: {
    success (){
      this.$emit('success', this.deleteData)
    },
    cancel (){
      this.$emit('cancel', this.deleteData)
    }
  }
}
</script>
<style lang="less" type="text/less">
  .confirm-wall{
    .w__dialog--box{
      width: 322px;
    }
    .w__dialog--body{
      /*padding: 10px 20px;*/
      line-height: 1.2;
    }
    .w__dialog--footer{
      padding: 17px 20px;
      border-top: 1px solid #ccc;
    }
    .btn{
      display: inline-block;
      box-sizing: content-box;
      padding: 0 10px;
      overflow: visible;
      min-width: 58px;
      height: 28px;
      line-height: 28px !important;
      border: 1px solid #ccc;
      border-radius: 4px;
      font-size: 12px;
      letter-spacing: 1px;
      word-spacing: normal;
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      &.primary{
        background: -webkit-gradient(linear, 50% 0, 50% 100%, color-stop(0%, #61a2e2), color-stop(100%, #2279e3));
        background: -webkit-linear-gradient(top, #61a2e2, #2279e3);
        background-color: #428ee2;
        border-color: #3d83d8;
        color: #fff !important;
        text-shadow: 1px 1px 0 #3068a6;
        height: 28px;
        line-height: 28px !important;
        &:hover{
          color: #fff !important;
          background-color: #61a2e2;
          background: -webkit-gradient(linear, 50% 0, 50% 100%, color-stop(0%, #6ab6ff), color-stop(100%, #3887e3));
          background: -webkit-linear-gradient(top, #6ab6ff, #3887e3);
        }
      }
      &.warning {
        background: -webkit-gradient(linear, 50% 0, 50% 100%, color-stop(0%, #fa9915), color-stop(100%, #d87e04));
        background: -webkit-linear-gradient(top, #fa9915, #d87e04);
        background: -moz-linear-gradient(top, #fa9915, #d87e04);
        background: -o-linear-gradient(top, #fa9915, #d87e04);
        background: -ms-linear-gradient(top, #fa9915, #d87e04);
        background: linear-gradient(top, #fa9915, #d87e04);
        background-color: #f18d05;
        border-color: #bf7004;
        color: #fff !important;
        text-shadow: 1px 1px 0 #b26b12;
        &:hover {
          color: #fff !important;
          background-color: #fa9915;
          background: -webkit-gradient(linear, 50% 0, 50% 100%, color-stop(0%, #ffb435), color-stop(100%, #ff8102));
          background: -webkit-linear-gradient(top, #ffb435, #ff8102);
          background: -moz-linear-gradient(top, #ffb435, #ff8102);
          background: -o-linear-gradient(top, #ffb435, #ff8102);
          background: -ms-linear-gradient(top, #ffb435, #ff8102);
          background: linear-gradient(top, #ffb435, #ff8102)
        }
      }
      &.cancel{
        color: #666 !important;
        text-decoration: none;
        box-sizing: content-box;
        padding: 0 10px;
        overflow: visible;
        min-width: 58px;
        height: 28px;
        line-height: 28px !important;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 12px;
        letter-spacing: 1px;
        word-spacing: normal;
        text-align: center;
        vertical-align: middle;
        cursor: pointer;
        box-shadow: inset 0 1px 0 rgba(255,255,255,0.5), 0 0 0 rgba(0,0,0,0.2);
        background-color: #eee;
        background: -webkit-gradient(linear, 50% 0, 50% 100%, color-stop(0%, #fbfbfb), color-stop(100%, #ddd));
        background: -webkit-linear-gradient(top, #fbfbfb, #ddd);
        margin-left: 10px;
        &:hover{
          color: #666 !important;
          background-color: #fbfbfb;
          text-decoration: none;
          background: -webkit-gradient(linear, 50% 0, 50% 100%, color-stop(0%, #fff), color-stop(100%, #f3f3f3));
          background: -webkit-linear-gradient(top, #fff, #f3f3f3);
        }
      }
    }
  }
  /*.confirm-content{*/
    /*position: relative;*/
    /*padding: 20px 0 20px 50px;*/
    /*margin: 5px 5px;*/
    /*.position-center{*/
      /*position: absolute;*/
      /*left: 0;*/
      /*top: 50%;*/
      /*width: 40px;*/
      /*height: 44px;*/
      /*margin-top: -22px;*/
      /*font-size: 40px;*/
    /*}*/
    /*.primary{*/
      /*color: #2079FA;*/
    /*}*/
    /*.warning{*/
      /*color: #ff7f00;*/
    /*}*/
    /*.content-txt{*/
      /*font-size: 16px;*/
      /*color: #666;*/
      /*word-break: break-all;*/
    /*}*/
    /*.content-small-txt{*/
      /*color: #999;*/
      /*display: block;*/
      /*font-size: 12px;*/
      /*margin-top: 5px;*/
    /*}*/
  /*}*/
</style>
